import React, { lazy } from 'react';

import { Route, Routes } from 'react-router-dom';

import { RiskDashboardServerApiProvider } from '@apis/risk-dashboard-server/risk-dashboard-server-api-provider';
import { useFeatureFlag } from '@packages/platform/feature-flags/use-feature-flag';

const ScanSchedulesPage = lazy(
  () => import('./pages/scan-schedules/scan-schedules.page'),
);
const ScanSchedulesPageV2 = lazy(
  () => import('./pages/scan-schedules/scan-schedules-v2.page'),
);
const CreateNewScanSchedule = lazy(
  () =>
    import('./pages/create-new-scan-schedule/create-new-scan-schedule.page'),
);
const EditScanSchedule = lazy(
  () => import('./pages/edit-scan-schedule/edit-scan-schedule.page'),
);

export const ScanSchedulesRoutes = () => {
  const [v2TableFF] = useFeatureFlag('SCAN_SCHEDULES_TABLE_V2');

  return (
    <RiskDashboardServerApiProvider>
      <Routes>
        {v2TableFF ? (
          <Route index element={<ScanSchedulesPageV2 />} />
        ) : (
          <Route index element={<ScanSchedulesPage />} />
        )}
        <Route path="create" element={<CreateNewScanSchedule />} />
        <Route path="edit/:scheduleId" element={<EditScanSchedule />} />
      </Routes>
    </RiskDashboardServerApiProvider>
  );
};
